import { render, staticRenderFns } from "./FileToUpload.vue?vue&type=template&id=3819a9af&"
import script from "./FileToUpload.vue?vue&type=script&lang=js&"
export * from "./FileToUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports